<script>
    import {url} from '@sveltech/routify';

    import {format} from 'date-fns';
    import {es} from 'date-fns/locale';

    import Boton from "../../UI/Boton.svelte";
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";

    import Mes from "../../Calendario/Mes.svelte";

    import Navegacion from "../../UI/Navegacion.svelte";

    export let navegacion = true;
    export let fecha;
    export let calendario;
    export let trabajador = null;
    export let marcado = null;
    export let tipo = null;
</script>

<Caja>
    <div slot="titulo">
        <Subtitulo icono="calendar_today">Calendario{#if tipo}{' '}({tipo}){/if}</Subtitulo>
    </div>

    <div slot="botones">
        {#if trabajador}
            <Boton href={$url('../calendario')} icono="edit">Editar calendario
            </Boton>
        {/if}
    </div>

    <Navegacion on:cambio botones={navegacion}>
        {format(fecha, 'MMMM yyyy', {locale: es})}
    </Navegacion>

    <Mes {calendario} {fecha} {marcado} on:click-en-dia on:click-en-dia-de-semana on:click-en-mes/>
</Caja>